import React from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  setProductType,
  setCurrentProduct,
  selectCurrentProduct,
} from "../../productSlice";

export default function ProductCard({ product, disableSection = false }) {
  const currentProduct = useSelector(selectCurrentProduct);
  const isSelected = product.id === currentProduct?.id;
  const dispatch = useDispatch();

  const handlePrimaryAction = (type, product) => {
    dispatch(setProductType(type));
    dispatch(setCurrentProduct(product));
  };

  return (
    <Card
      sx={{
        backgroundColor: "#eaecee",
        borderRadius: "15px",
        boxShadow: 2,
        minWidth: "380px",
        maxWidth: "380px",
        maxHeight: "225px",
        minHeight: "225px",
        pb: "10px",
      }}
    >
      <CardContent
        sx={{ color: "white", bgcolor: "#0c3759", pt: "20px", pb: "20px" }}
      >
        <Grid container sx={{ alignItems: "center" }}>
          <Grid item xs={3} sx={{ display: "flex", justifyContent: "center" }}>
            <Icon sx={{ scale: "180%" }}>{product.icon}</Icon>
          </Grid>
          <Grid item xs={7}>
            <Typography variant="h5" component="div">
              {product.title}
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() =>
                handlePrimaryAction(product.api_key.toLowerCase(), product)
              }
              isSelected={isSelected}
            >
              <ArrowCircleRightRoundedIcon
                sx={{ color: "white", height: 40, width: 40 }}
              />
            </Button>
          </Grid>
        </Grid>
      </CardContent>

      <CardContent sx={{ bgcolor: "#eaecee" }}>
        {!disableSection ? (
          <>
            <Grid
              container
              sx={{
                alignItems: "center",
                px: "20px",
                py: "15px",
              }}
            >
              <Grid xs={12}>
                <Typography variant="subtitle2" component="div">
                  Description:
                </Typography>
              </Grid>
              <Grid xs={12} marginY={"5px"}>
                <Typography variant="subtitle1" component="div">
                  <i>
                    <b>{product.description}</b>
                  </i>
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ mb: "15px", bgcolor: "#eaecee" }}>
              Empty section
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
}
